<template>
  <div>
    <Loader v-if="isLoading"></Loader>
    <EXCMCarUserDataForm
      v-else
      :closeModal="closeModal"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations" />

<!--    <router-link-->
<!--      :to="{ name: 'EXCMCarUserDataList' }"-->
<!--      class="btn btn-default">Back to list</router-link>-->
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMCarUserDataForm from './Form'
import Loader from '../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('excmcaruserdata/create')

export default {
  components: {
    EXCMCarUserDataForm,
    Loader
  },

  props: {
    serviceman: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      item: { routePoints: [] }
    }
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      if (this.$route.name === 'ServicemenShow' || this.$route.name === 'DailyPlanShow') {
        this.$store.state.modals.userdata.assignCarCreate.created = 1
        this.$store.state.modals.userdata.assignCarCreate.close = 1
      } else {
        this.$router.push({ name: 'EXCMCarUserDataUpdate', params: { id: created['@id'] } })
      }
    }
  },

  created () {
    if (this.serviceman) {
      this.item.userData = this.serviceman['@id']
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      if (this.item.dateFrom) {
        this.item.dateFrom = this.$moment(this.item.dateFrom).format('YYYY-MM-DD')
      }
      if (this.item.dateTo) {
        this.item.dateTo = this.$moment(this.item.dateTo).format('YYYY-MM-DD 23:59:59')
      }
      this.create(this.item)
    },

    closeModal () {
      this.$store.state.modals.userdata.assignCarCreate.close = 1
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
